var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuredocCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161732",
    "data-name": "Group 161732",
    transform: "translate(-325 -531.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    width: 23,
    height: 23,
    rx: 4,
    transform: "translate(325 531.09)",
    fill: "#fbf4ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161728",
    "data-name": "Group 161728",
    transform: "translate(-0.053 -0.296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    width: 11,
    height: 10,
    rx: 2,
    transform: "translate(331.053 538.385)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M7,11.273l1.7,1.7,1.136-1.136L12.682,9",
    transform: "translate(326.349 532.101)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredocCheckboxIcon);
export default __webpack_public_path__ + "static/media/securedoc-checkbox-icon.9ecd5431ba15dd5524e5d651225f6133.svg";
export { ForwardRef as ReactComponent };